(function () {
  'use strict';
  // 4 okt 2026 — Fix voor 'Required parameter missing or invalid: items'.
  // Het inlijstformulier (custom_liquid op de productpagina) zette de keuzelijst
  // standaard op 'Zonder lijst', ook als die variant uitverkocht (uitgeschakeld) is.
  // Een uitgeschakelde optie wordt niet meegestuurd, dus Shopify kreeg een lege
  // bestelling en toonde een foutpagina.
  function geldig(o) { return !!(o && o.value && !o.disabled); }
  function herstel(form) {
    if (!form || form.getAttribute('data-fs-fixed')) return;
    form.setAttribute('data-fs-fixed', '1');
    var sel = form.querySelector('select[name="id"]');
    var btn = form.querySelector('.custom-buy-button, button[type="submit"]');
    if (!sel) return;
    if (geldig(sel.selectedOptions[0])) return;
    var eerste = null;
    for (var i = 0; i < sel.options.length; i++) { if (geldig(sel.options[i])) { eerste = sel.options[i]; break; } }
    var wrap = form.closest('.s4-frame-select-wrap');
    var upgrade = form.querySelector('.s4-frame-upgrade');
    if (eerste) {
      // Zonder lijst is op, een andere keuze nog niet: toon de gewone keuzelijst.
      if (upgrade) upgrade.style.display = 'none';
      sel.style.display = '';
      var label = wrap ? wrap.querySelector('.s4-frame-label') : null;
      if (label) label.style.display = '';
      sel.value = eerste.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (btn) {
      // Alles uitverkocht: geen koopknop die een foutpagina oplevert.
      if (upgrade) upgrade.style.display = 'none';
      btn.disabled = true;
      btn.textContent = 'Uitverkocht';
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
    }
  }
  function alles() {
    var forms = document.querySelectorAll('form[id^="s4-frame-form-"]');
    for (var i = 0; i < forms.length; i++) herstel(forms[i]);
  }
  // Vangnet: nooit een formulier zonder geldige variant versturen.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id || form.id.indexOf('s4-frame-form-') !== 0) return;
    var sel = form.querySelector('select[name="id"]');
    if (sel && !geldig(sel.selectedOptions[0])) {
      e.preventDefault();
      form.removeAttribute('data-fs-fixed');
      herstel(form);
      if (sel && geldig(sel.selectedOptions[0])) { sel.focus(); }
    }
  }, true);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', alles); } else { alles(); }
  // Snel-toevoegen-venster op collectiepagina's laadt het formulier later in.
  var gepland = false;
  new MutationObserver(function () {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(function () { gepland = false; alles(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
